// src/helpers/register/fractionSimplification.ts
var findGreatestCommonDivisor = (a, b) => {
  while (b !== 0) {
    const t = b;
    b = a % b;
    a = t;
  }
  return a;
};
var findLeastCommonMultiple = (a, b) => {
  return a * b / findGreatestCommonDivisor(a, b);
};
var sumAndSimplifyFractions = (fractions) => {
  if (fractions.length === 0)
    return { unit: 1, numerator: 0, denominator: 0 };
  let commonDenominator = fractions[0].denominator;
  for (let i = 1; i < fractions.length; i++) {
    commonDenominator = findLeastCommonMultiple(
      commonDenominator,
      fractions[i].denominator
    );
  }
  let sumNumerator = 0;
  for (const fraction of fractions) {
    sumNumerator += fraction.numerator * (commonDenominator / fraction.denominator);
  }
  if (isNaN(sumNumerator))
    sumNumerator = 0;
  if (isNaN(commonDenominator))
    commonDenominator = 0;
  const resultGcd = findGreatestCommonDivisor(sumNumerator, commonDenominator);
  const simplifiedNumerator = sumNumerator / resultGcd;
  const simplifiedDenominator = commonDenominator / resultGcd;
  const unit = Math.floor(simplifiedNumerator / simplifiedDenominator);
  const fractionalNumerator = simplifiedNumerator % simplifiedDenominator;
  if (fractionalNumerator === 0) {
    return { unit };
  } else {
    return {
      unit,
      numerator: fractionalNumerator,
      denominator: simplifiedDenominator
    };
  }
};
var getDisplayedFraction = ({
  unit,
  numerator,
  denominator
}) => {
  return !numerator && !denominator ? `${unit}` : denominator === 1 ? `${numerator}` : unit ? `${unit} ${numerator}/${denominator}` : `${numerator}/${denominator}`;
};

export { getDisplayedFraction, sumAndSimplifyFractions };
